import * as React from 'react';
import { Button, Flex, Text } from '@fluentui/react-northstar';
import { Helpers } from '../helpers/Helpers';

export default class HomeComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
            window.location.href = `https://${Helpers.getAppId()}.com`;
    }
    render() {
        return (<Text content='Redirecting...' />);        
    }
}
export class BaseComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
            
    }
    handleButtonClicked(path){
        window.location.href = `/${path}?fromHome=true`;
    }
    render() {
        return (<Flex column vAlign='center' gap='gap.medium'>
            <Button content='Meet for a Matter' onClick={(e)=>this.handleButtonClicked('casesmeet')} />
            <Button content='Meet for a Contract' onClick={(e)=>this.handleButtonClicked('contractmeet')} />
            <Button content='Meet for a Hearing' onClick={(e)=>this.handleButtonClicked('hearingmeet')} />
            <Button content='Settings' onClick={(e)=>this.handleButtonClicked('settings')} />
        </Flex>
    );        
    }
}